import { HrPerAwardKey } from './hr-per-award-key';
import { HrPerAddressKey } from './hr-per-address-key';
import { HrPerBankKey } from './hr-per-bank-key';
import { HrPerBorrowingKey } from './hr-per-borrowing-key';
import { HrPerBoxesKey } from './hr-per-boxes-key';
import { HrOrgCardsKey } from './hr-org-cards-key';
import { HrPerCertificateKey } from './hr-per-certificate-key';
import { HrPerContractKey } from './hr-per-contract-key';
import { HrPerDegreeKey } from './hr-per-degree-key';
import { HrPerCourtKey } from './hr-per-court-key';
import { HrPerEduInstFacultyKey } from './hr-per-edu-inst-faculty-key';
import { HrPerEducationKey } from './hr-per-education-key';
import { HrPerExamKey } from './hr-per-exam-key';
import { HrPerSubExamKey } from './hr-per-subexam-key';
import { HrPerExternalServiceKey } from './hr-per-external-service-key';
import { HrPerFamilyKey } from './hr-per-family-key';
import { HrPerForeignLanguageKey } from './hr-per-foreign-language-key';
import { HrPerHealthKey } from './hr-per-health-key';
import { HrPerHierarchyGroupDetailKey } from './hr-per-hierarchy-group-detail-key';
import { HrPerHistoricalDataKey } from './hr-per-historical-data-key';
import { HrPerIdentificationKey } from './hr-per-identification-key';
import { HrPerIdentityKey } from './hr-per-identity-key';
import { HrPerInstFacultyBranchKey } from './hr-per-inst-faculty-branch-key';
import { HrPerMilitaryKey } from './hr-per-military-key';
import { HrPerObjectConnectionKey } from './hr-per-object-connection-key';
import { HrPerObjectContentKey } from './hr-per-object-content-key';
import { HrPerObjectDefinitionKey } from './hr-per-object-definition-key';
import { HrPerObjectDetailKey } from './hr-per-object-detail-key';
import { HrPerObjectRelationshipKey } from './hr-per-object-relationship-key';
import { HrPerOrganizationManagementKey } from './hr-per-organization-management-key';
import { HrPerPersonnelKey } from './hr-per-personnel-key';
import { HrPerPersonnelOrganizationKey } from './hr-per-personnel-organization-key';
import { HrPerPhysicalStandardKey } from './hr-per-physical-standard-key';
import { HrPerPunishmentKey } from './hr-per-punishment-key';
import { HrPerSpecialSituationKey } from './hr-per-special-situation-key';
import { HrPerSubtypeSchoolKey } from './hr-per-subtype-school-key';
import { HrPerSyndicateKey } from './hr-per-syndicate-key';
import { HrPerTelephoneKey } from './hr-per-telephone-key';
import { HrPerTypeEduSubtypeKey } from './hr-per-type-edu-subtype-key';
import { HrPerVehicleKey } from './hr-per-vehicle-key';
import { HrPerWeaponKey } from './hr-per-weapon-key';
import { HrOrganizationHeaderKey } from './hr-organization-header';
import { CommonKey } from './common-key';
import { HrCommonKey } from './hr-common-key';
import { HrCommonCodeTextKey } from './hr-common-code-text-key';
import { HrPayWageManagementCardKey } from './hr-pay-wage-management-card-key';
import { HrPayCommonPayKey } from './hr-pay-common-pay-key';
import { HrGenCertificateKey } from './hr-gen-certificate-key';
import { HrGenEmployeeSubtypeKey } from './hr-gen-employee-subtype-key';
import { HrGenHrmDetailKey } from './hr-gen-hrm-detail-key';
import { HrGenHrmTypeKey } from './hr-gen-hrm-type-key';
import { HrGenWorkSubareaKey } from './hr-gen-work-subarea-key';
import { HrGenHrmDetailTypeKey } from './hr-gen-hrm-detail-type-key';
import { HrPayIndividualPayKey } from './hr-pay-individual-pay-key';
import { HrPayEngineScriptKey } from './hr-pay-engine-script-key';
import { HrPayDeductionKey } from './hr-pay-deduction-key';
import { HrPayAdditionalPayKey } from './hr-pay-additional-pay-key';
import { HrPayWageTypeKey } from './hr-pay-wage-type-key';
import { HrPayGroupWorkSubareaKey } from './hr-pay-group-work-subarea-key';
import { HrPayGroupEmployeeSubtypeKey } from './hr-pay-group-employee-subtype-key';
import { HrPayPeriodDateKey } from './hr-pay-period-date-key';
import { HrPayPayrollSwitchKey } from './hr-pay-payroll-switch-key';
import { HrPayPayrollSwitchStateKey } from './hr-pay-payroll-switch-state-key';
import { HrPayConstantAmountKey } from './hr-pay-constant-amount-key';
import { HrPayWtMannerValueKey } from './hr-pay-wt-manner-value-key';
import { HrPayConstantNumberKey } from './hr-pay-constant-number-key';
import { HrPayConstantPublicKey } from './hr-pay-constant-public-key';
import { HrPayWtCumulativeKey } from './hr-pay-wt-cumulative-key';
import { HrPerIdentificationSubtypeKey } from './hr-per-identification-subtype-key';
import { HrPayEngineResultKey } from './hr-pay-engine-result-key';
import { HrOrganizationResponsibilityKey } from './hr-org-responsibility-key';
import { HrPerOrganizationGeneralInfoKey } from './hr-per-organization-general-info-key';
import { HrPerCriteriaCatalogDefinitionKey } from './hr-per-criteria-catalog-definition-key';
import { HrPerDisabilityKey } from './hr-per-disability-key';
import { HrPayNameKey } from './hr-pay-name-key';
import { HrPerSuspensionKey } from './hr-per-suspension-key';
import { HrPerMovementKey } from './hr-per-movement-key';

import { HrPerMovementReturnStatusKey } from './hr-per-movement-return-status-key';
import { HrPerMovementServiceStatusKey } from './hr-per-movement-service-status-key';
import { HrPerMovementStMandatoryFieldsKey } from './hr-per-movement-st-mandatory-fields-key';
import { HrPerAttachmentKey } from './hr-per-attachment-key';
import { HrPerEvaluationAreaDefinitionKey } from './hr-per-evaluation-area-definition-key';
import { HrPerEvaluationRuleDefinitionKey } from './hr-per-evaluation-rule-definition-key';
import { HrPerEvaluationPathDefinitionKey } from './hr-per-evaluation-path-definition-key';
import { HrPerMovementInfoKey } from './hr-per-movement-info-key';
import { HrPaySstPercentageKey } from './hr-pay-sst-percentage-key';
import { HrPerLeaveRequestKey } from './hr-per-leave-request-key';
import { HrBpmn } from './hr-bpmn';
import { HrPrfUnitTypeKey } from './hr-prf-unit-type-key';
import { HrPerExperienceKey } from './hr-per-experience-key';

export class HrTranslateKey {
    public static common = CommonKey;
    public static hrCommon = HrCommonKey;
    public static hrCommonCodeText = HrCommonCodeTextKey;
    public static hrPayWageManagementCard = HrPayWageManagementCardKey;
    public static hrPayCommonPay = HrPayCommonPayKey;
    public static hrPayEngineScript = HrPayEngineScriptKey;
    public static hrPayEngineResult = HrPayEngineResultKey;
    public static hrPayAdditionalPay = HrPayAdditionalPayKey;
    public static hrPayIndividualPay = HrPayIndividualPayKey;
    public static hrPayDeduction = HrPayDeductionKey;
    public static hrPayPayrollSwitch = HrPayPayrollSwitchKey;
    public static hrPayPayrollSwitchState = HrPayPayrollSwitchStateKey;
    public static hrGenCertificate = HrGenCertificateKey;
    public static hrGenEmployeeSubtype = HrGenEmployeeSubtypeKey;
    public static hrGenHrmDetail = HrGenHrmDetailKey;
    public static hrGenHrmDetailType = HrGenHrmDetailTypeKey;
    public static hrGenHrmType = HrGenHrmTypeKey;
    public static hrGenWorkSubarea = HrGenWorkSubareaKey;
    public static hrPerAddress = HrPerAddressKey;
    public static hrPerAward = HrPerAwardKey;
    public static hrPerBank = HrPerBankKey;
    public static hrPerBorrowing = HrPerBorrowingKey;
    public static hrPerBoxes = HrPerBoxesKey;
    public static hrOrgCards = HrOrgCardsKey;
    public static hrPerCertificate = HrPerCertificateKey;
    public static hrPerContract = HrPerContractKey;
    public static hrPerCourt = HrPerCourtKey;
    public static hrPerDegree = HrPerDegreeKey;
    public static hrPerEduInstFaculty = HrPerEduInstFacultyKey;
    public static hrPerEducation = HrPerEducationKey;
    public static hrPerExam = HrPerExamKey;
    public static hrPerSubExam = HrPerSubExamKey;
    public static hrPerExternalService = HrPerExternalServiceKey;
    public static hrPerFamily = HrPerFamilyKey;
    public static hrPerForeignLanguage = HrPerForeignLanguageKey;
    public static hrPerHealth = HrPerHealthKey;
    public static hrPerHieGrpDetail = HrPerHierarchyGroupDetailKey;
    public static hrPerHistoricalData = HrPerHistoricalDataKey;
    public static hrPerIdentification = HrPerIdentificationKey;
    public static hrPerIdentity = HrPerIdentityKey;
    public static hrPerInstFacBranch = HrPerInstFacultyBranchKey;
    public static hrPerMilitary = HrPerMilitaryKey;
    public static hrPerObjectConnection = HrPerObjectConnectionKey;
    public static hrPerObjectContent = HrPerObjectContentKey;
    public static hrPerObjectDefinition = HrPerObjectDefinitionKey;
    public static hrPerCriteriaCatalogDefinition = HrPerCriteriaCatalogDefinitionKey;
    public static hrPerObjectDetail = HrPerObjectDetailKey;
    public static hrPerObjectRelationship = HrPerObjectRelationshipKey;
    public static hrPerOrganMana = HrPerOrganizationManagementKey;
    public static hrPerPersonnel = HrPerPersonnelKey;
    public static hrPerPersonnelOrg = HrPerPersonnelOrganizationKey;
    public static hrPerPhysicalStandard = HrPerPhysicalStandardKey;
    public static hrPerExperience = HrPerExperienceKey;
    public static hrPerPunishment = HrPerPunishmentKey;
    public static hrPerSpecialSituation = HrPerSpecialSituationKey;
    public static hrPerSubtypeSchool = HrPerSubtypeSchoolKey;
    public static hrPerSyndicate = HrPerSyndicateKey;
    public static hrPerTelephone = HrPerTelephoneKey;
    public static hrPerTypeEduSubtype = HrPerTypeEduSubtypeKey;
    public static hrPerVehicle = HrPerVehicleKey;
    public static hrPerWeapon = HrPerWeaponKey;
    public static hrOrganizationHeader = HrOrganizationHeaderKey;

    public static hrPerMovementReturnStatus = HrPerMovementReturnStatusKey;
    public static hrPerMovementServiceStatus = HrPerMovementServiceStatusKey;
    public static hrPerMovementStMandatoryFields = HrPerMovementStMandatoryFieldsKey;
    public static hrPayWageType = HrPayWageTypeKey;
    public static hrPayName = HrPayNameKey;
    public static hrPayGroupWorkSubarea = HrPayGroupWorkSubareaKey;
    public static hrPayGroupEmployeeSubtype = HrPayGroupEmployeeSubtypeKey;
    public static hrPayPeriodDate = HrPayPeriodDateKey;
    public static hrPayConstantAmount = HrPayConstantAmountKey;
    public static hrPayConstantNumber = HrPayConstantNumberKey;
    public static hrPayConstantPublic = HrPayConstantPublicKey;
    public static hrPaySstPercentage = HrPaySstPercentageKey;
    public static hrPayWtMannerValue = HrPayWtMannerValueKey;
    public static hrPayWtCumulative = HrPayWtCumulativeKey;
    public static hrPerIdentificationSubtype = HrPerIdentificationSubtypeKey;
    public static hrPerOrganizationGeneralInfo = HrPerOrganizationGeneralInfoKey;
    public static hrOrganizationResponsibility = HrOrganizationResponsibilityKey;
    public static hrPerDisability = HrPerDisabilityKey;
    public static hrPerSuspension = HrPerSuspensionKey;
    public static hrPerMovement = HrPerMovementKey;
    public static hrPerMovementInfo = HrPerMovementInfoKey;
    public static hrPerAttachment = HrPerAttachmentKey;
    public static hrPerEvaluationRuleDefinition = HrPerEvaluationRuleDefinitionKey;
    public static hrPerEvaluationPathDefinition = HrPerEvaluationPathDefinitionKey;
    public static hrPerEvaluationAreaDefinition = HrPerEvaluationAreaDefinitionKey;
    public static hrPerLeaveRequest = HrPerLeaveRequestKey;
    public static hrBpmn = HrBpmn;
    public static hrPrfUnitType = HrPrfUnitTypeKey;
}
